import * as angular from 'angular';

import { RegentsPlanningStepperTransferModule } from './regents-planning-stepper-transfer/regents-planning-stepper-transfer.module';
import { RegentsPlanningTableTransferModule } from './regents-planning-table-transfer/regents-planning-table-transfer.module';
import { RegentsPlanningWizardTransferComponent } from './regents-planning-wizard-transfer.component';

export const RegentsPlanningWizardTransferModule = angular
  .module('regentsPlanningWizardTransferModule', [
    RegentsPlanningStepperTransferModule,
    RegentsPlanningTableTransferModule,
  ])
  .component('regentsPlanningWizardTransfer', RegentsPlanningWizardTransferComponent).name;
